"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppendAssets = AppendAssets;
var _react = _interopRequireDefault(require("react"));
var _Core_css = _interopRequireDefault(require("./Core_css"));
function AppendAssets() {
  let headElem = document.getElementsByTagName("head")[0];

  // insert base theme assets.. in reverse order here, so they end up the order we want in the head tag.

  // insert base theme styles
  if (!headElem.querySelector('style[id="adc_theme_core"]')) {
    let theme = document.createElement("style");
    theme.id = "adc_theme_core";
    theme.innerHTML = _Core_css.default;
    theme.type = "text/css";
    headElem.insertBefore(theme, headElem.firstChild);
  }

  // insert base icon font
  if (!headElem.querySelector('link[id="adc_icons_reg"]')) {
    let icons5 = document.createElement("link");
    icons5.media = "all";
    icons5.rel = "stylesheet";
    icons5.id = "adc_icons_sharp";
    icons5.href = "https://fonts.googleapis.com/icon?family=Material+Icons+Sharp";
    headElem.insertBefore(icons5, headElem.firstChild);
    let icons4 = document.createElement("link");
    icons4.media = "all";
    icons4.rel = "stylesheet";
    icons4.id = "adc_icons_two_tone";
    icons4.href = "https://fonts.googleapis.com/icon?family=Material+Icons+Two+Tone";
    headElem.insertBefore(icons4, headElem.firstChild);
    let icons3 = document.createElement("link");
    icons3.media = "all";
    icons3.rel = "stylesheet";
    icons3.id = "adc_icons_round";
    icons3.href = "https://fonts.googleapis.com/icon?family=Material+Icons+Round";
    headElem.insertBefore(icons3, headElem.firstChild);
    let icons2 = document.createElement("link");
    icons2.media = "all";
    icons2.rel = "stylesheet";
    icons2.id = "adc_icons_outlined";
    icons2.href = "https://fonts.googleapis.com/icon?family=Material+Icons+Outlined";
    headElem.insertBefore(icons2, headElem.firstChild);
    let icons1 = document.createElement("link");
    icons1.media = "all";
    icons1.rel = "stylesheet";
    icons1.id = "adc_icons_reg";
    icons1.href = "https://fonts.googleapis.com/icon?family=Material+Icons";
    headElem.insertBefore(icons1, headElem.firstChild);
  }

  // insert base text font
  if (!headElem.querySelector('link[id="adc_font"]')) {
    let fonts = document.createElement("link");
    fonts.media = "all";
    fonts.rel = "stylesheet";
    fonts.id = "adc_font";
    fonts.href = "https://static.accessdevelopment.com/arcui/fonts.css";
    headElem.insertBefore(fonts, headElem.firstChild);
  }
  return /*#__PURE__*/_react.default.createElement("div", null);
}